<template>
  <div class="rounded-sm m-2 flex shadow-md cursor-pointer">
    <KImage :src="image" style="min-width: 170px;" />
    <div class="flex flex-col py-2.5 px-4 mb-1.5" style="width: 330px;">
      <div class="flex justify-between items-center mb-1.5">
        <span class="text-left text-xl font-semibold overflow-hidden truncate">
          {{ title }}
        </span>
        <div
          class="text-secondary ml-2 py-2 px-2.5 flex items-center bg-primary rounded"
        >
          <FontAwesomeIcon class="mr-2.5" icon="stopwatch" />
          <span class="flex align-center font-semibold">
            {{ cookingTime }}"
          </span>
        </div>
      </div>
      <div class="flex justify-start text-black mb-1">
        <span class="text-base font-medium">Macro Split</span>
      </div>
      <div class="flex flex-col justify-center mr-16">
        <div class="flex justify-between">
          <span class="text-sm">Proteins</span>
          <span class="text-secondary font-semibold text-sm">
            {{ proteins }}%
          </span>
        </div>
        <div class="flex justify-between my-0.5">
          <span class="text-sm">Fats</span>
          <span class="text-secondary font-semibold text-sm">
            {{ fats }}%
          </span>
        </div>
        <div class="flex justify-between">
          <span class="text-sm mr-14">Carbohydrates</span>
          <span class="text-secondary font-semibold text-sm">
            {{ carbohydrates }}%
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecipeCard",
  components: {},
  props: {
    recipe: {
      type: Object,
      default: () => ({
        title: "Meal deal from coop",
        cooking_time: 30,
        proteins: 35,
        fats: 25,
        carbohydrates: 40,
        image: "https://images.unsplash.com/photo-1555985202-12975b0235dc"
      })
    }
  },
  computed: {
    image() {
      return this.recipe.image;
    },
    title() {
      return this.recipe.title;
    },
    cookingTime() {
      return this.recipe.cooking_time;
    },
    proteins() {
      return this.recipe.proteins;
    },
    fats() {
      return this.recipe.fats;
    },
    carbohydrates() {
      return this.recipe.carbohydrates;
    }
  },
  data() {
    return {
      import_to_file: ""
    };
  },
  created() {}
};
</script>

<style></style>
